console.log('[FE_x] V 1.1.0');
function FEXception(msg) {
   this.message = msg;
   this.name = 'FEXception';
}

/** 
 * Base implementation of functions for FEXI 
 */
function FE$BaseFunctionExecutor() {
   console.log('[FEXI_Base] Creating fexi base executor');
   this.functions = {};
   
   this.functions['indexOf'] = this._indexOf;
   this.functions['ifElse'] = this._ifElse;
   this.functions['switch'] = this._switch;
   this.functions['testRegExp'] = this._testRegExp;
   this.functions['length'] = this._length;
   this.functions['contains'] = this._contains;
   this.functions['choiceOValue'] = this._chValue;

   console.log('[FEXI_Base] Functions defined: ' + this.functions);
}

FE$BaseFunctionExecutor.prototype = new Object();

FE$BaseFunctionExecutor.prototype._chValue = function(args) {
   console.log('[FEXI_b] Executing length of ', args);
   if (args.length != 1 || typeof args[0] != 'object') {
      throw new FEXception('chValue requires one object argument obtained ' + args);
   }
   return args[0]['']? args[0]['']:'';
}

FE$BaseFunctionExecutor.prototype._length = function(args) {
   console.log('[FEXI_b] Executing length of ', args);
   if (args.length != 1) {
      throw new FEXception('length requires one argument, obtained ' + args.length);
   }
   if (! Array.isArray(args[0]) && typeof args[0] != 'string') {
      throw new FEXception('Expected length argument to be of type array but obtained: ' + args[0]);
   }

   return args[0].length;
}

FE$BaseFunctionExecutor.prototype._contains = function(args) {
   console.log('[FEXI_b] Executing contains of ', args);
   if (args.length != 2) {
      throw new FEXception('contains requires two arguments, obtained ' + args.length);
   }
   
   if (Array.isArray(args[0])) {
      return args[0].includes(args[1]);
   }
   if (typeof args[0] == 'string') {
      return args[0].indexOf(args[1]) != -1;
   }
   if (typeof args[0] == 'object' && '' in args[0] && typeof args[0][''] == 'string') {
      return args[0][''].indexOf(args[1]) != -1;
   }
   throw new FEXception('Expected contains first argument to be of type array or string but obtained: ' + args[0]);
}
FE$BaseFunctionExecutor.prototype._indexOf = function(args) {
   console.log('[FEXI_b] Executing index of ', args);
   if (args.length != 2) {
      throw new FEXception('indexOf function requires 2 arguments, obtained ', args);
   }
   if (args[0] == null) {
      return -1;
   }
   var ret;
   if(args[0] && args[0].array){
      if(args[0].array.length && typeof args[0].array[0] == 'object'){
         //case Object
         return args[0].array.find(o => o.value==args[1])? 1 :-1;
      }else{
         //case Array
         return args[0].array.indexOf(args[1]);
      }
   }else{
      // Case Value
      ret = (args[0] == args[1])? 1 : -1;
   }
   
   console.log('[fe$ngine] FEXI Executing indexOf returning ' + ret, args);
   return ret;
}
FE$BaseFunctionExecutor.prototype._testRegExp = function(args) {
   if (args.length < 2) {
      throw new FEXception('matches function requires 2 arguments, obtained ', args);
   }
   var expression = new RegExp(args[0]);
   var value = args[1];
   console.log('[FEXI_b] Executing testRegExp with expression "' + expression + "' against '" + value + '"');
   return expression.test(value);
}



FE$BaseFunctionExecutor.prototype._ifElse = function(args) {
   console.log('[FEXI_b] Executing ifElse of ', args);
   if (args.length < 2) {
      throw new FEXception('ifElse requires at least 2 arguments, obtained ', args);
   }
   if (typeof args[0] != 'boolean') {
      throw new FEXception('ifElse requires first parameter to be boolean but found: ', args[0]);
   }
   if (args[0]) {
      return args[1];
   } else if (args.length > 2) {
      return args[2];
   }
}
FE$BaseFunctionExecutor.prototype._switch = function(args) {
   console.log('[FEXI_b] Executing ifElse of ', args);
   if (args.length < 3) {
      throw new FEXception('switch requires at least 3 arguments, obtained ', args);
   }
   
   for (var i=1; i < args.length; i+=2) {
      if (args.length == i + 1) {
         return args[i]; // Default value
      } else if (args[0] == args[i]) {
         return args[i+1];
      }
   }
}

FE$BaseFunctionExecutor.prototype.addFunction = function(name, fnc) {
   console.log('[FEXI_Base] Adding function: ' + name + ' to ' + this.functions);
   this.functions[name] = fnc;
}

FE$BaseFunctionExecutor.prototype.execute = function(name, args) {
   if (!(name in this.functions)) {
      throw new FEXception('Attempt to execute a undefined FEXI function: "' + name + '"');
   }
   console.log('[FEXI_Base] Executing function ' + name + ' with args: ' + args);
   var fnc = this.functions[name];
   return fnc(args);
}

FE$BaseFunctionExecutor.prototype.getFunctionSolver = function() {
   return this.execute.bind(this);
}
function FE$XUtils_def() {
   this.matchesAny = function(str, options) {
      for (var i=0; i < options.length; i++) {
         if (options[i] == str) {
            return true;
         }
      }
      return false;
   }
};

var FE$XUtils = new FE$XUtils_def();

function FE$XInterpreter_def() {

   var OP_PRECEDENCE = [ 'not', '*', '/', '+', '-', '==', '!=', '>', '<', '>=', '<=', 'and', 'or'];
   var OP_UNARY = ['not'];
   var tokenIndex = 0;

   this.TYPE_NUMBER = 'number';
   this.TYPE_IDENTIFIER = 'identifier';
   this.TYPE_OPERATION = 'operation';
   this.TYPE_FUNCTION = 'function';
   this.TYPE_STRING = 'string';
   this.TYPE_BOOLEAN = 'boolean';
   this.TYPE_ARRAYOFFSET = 'arrayOffset';
   this.TYPE_SUBFIELD = 'subField';

   this.parse = function(str) {
      var tokenized = FE$XITokenizer.tokenize(str);
      tokenIndex = 0;
      var ast = this.parseStep(tokenized);
      console.log('[FEX] Parsed "' + str + '" as ' + JSON.stringify(ast));
      return ast;
   }

   var worker = null;
   var initializeWorker = function() {
      // Functions added to worker to listen messages
      function workerPostMessage() {
         // Method to listen to worker requests
         this.onmessage = function(e) {
            var start = new Date();
            // console.log('[FEXI_wkr] Received message: ' + e.data);
            var ast = FE$XInterpreter.parse(e.data);
            // console.log('[FEXI_wkr] Parsed as: ' + JSON.stringify(ast));
            this.postMessage({'input':e.data, 'output':ast});
            console.log('[FEXI_wkr] Parse time: ' + (new Date().getTime() - start.getTime()) / 1000.0 + 's. for ' + e.data);

         }
      }
      // Build worker script
      fncStr = 'function() {'
         + ' var FE$XInterpreter = new (' + FE$XInterpreter_def + ')();\n'
         + 'var FE$XITokenizer = new (' + FE$XITokenizer_def + ')();\n'
         + 'var FE$XUtils = new (' + FE$XUtils_def + ')();\n'
         + 'var FEXception = ' + FEXception + ';\n'
         + '(' + workerPostMessage + ')()\n'
         + 'console.log(\'[FEXI_wkr] Initialized worker \');\n'
      + '}'

      var fncStr = '(' + fncStr + ')();';

      var fncStr = fncStr.replace('"use strict";', '')
      console.log('[FEX_wkr] Using worker with code: \n' + fncStr);
      var blob = new Blob([fncStr]);

      var blobUrl = (window.URL ? URL : webkitURL).createObjectURL(blob, {
          type: 'application/javascript; charset=utf-8'
      });
      worker = new Worker(blobUrl);

      worker.onmessage = onParseResponse.bind(this);
      window.onunload = function(w) {
         console.log('[FEX] Terminating worker: ', w);
         w.terminate();
         console.log('[FEX] Terminated worker: ', w);
      }.bind(this, worker);
   }
   var parseCallbacks = {};
   // Method to listen to worker parsing responses
   var onParseResponse = function(message) {
      
      var input = message.data.input;
      var output = message.data.output;
      var callback = parseCallbacks[input];
      // console.log('[FEX] Received worker parse response for ' + input + JSON.stringify(message.data));
      if (!callback) {
         console.log('[FEX] Worker response is from no requested input? ' + input);
      } else {
         callback(output);
         delete parseCallbacks[input];
      }
   }
   this.parseAsync = function(str, callback) {
      if (!callback) {
         throw new FEXception('No callback passed. Unable to process async');
      }
      if (worker == null) {
         initializeWorker.bind(this)();
      }
      parseCallbacks[str] = callback;
      worker.postMessage(str);
      
    
   }
   
   this.evaluate = function(ast, idSolver, fncExecutor) {
      // console.log('[FEX] Evaluating node: ' + ast.type);
      if (ast.type == this.TYPE_OPERATION) {
         // console.log('[FEX] Detected operation: ' + ast.text);
         var left = this.evaluate(ast.left, idSolver, fncExecutor);
         var right = null;
         if (!ast.isUnary) {
            right = this.evaluate(ast.right, idSolver, fncExecutor);
         }
         return operate(ast.text, left, right)
      } else if (ast.type == this.TYPE_SUBFIELD) {

         var left = this.evaluate(ast.left, idSolver, fncExecutor);
         // Left is always evaluated as a value..right has a new identifier or value to apply to it
         if (! (typeof left == 'object')) {
            throw new FEXception('Could not evaluate subfield. Referencing something that is not an object ' + JSON.stringify(ast.left));
         }
         if (! (ast.right.text in left)) {
            return null;
         }
         return left[ast.right.text];
      } else if (ast.type == this.TYPE_ARRAYOFFSET) {

         var left = this.evaluate(ast.left, idSolver, fncExecutor);
         // Left is always evaluated as a value..right has a new identifier or value to apply to it
         if (!Array.isArray(left)) {
            throw new FEXception('Could not evaluate subfield. Referencing something that is not an array ' + JSON.stringify(ast.left));
         }
         var right = this.evaluate(ast.right, idSolver, fncExecutor);
         if (! (typeof right == 'number')) {
            throw new FEXception('Could not evalute array offset. Value is not a number: ' + right + ' - ' + JSON.stringify(ast.right));
         }
         if (left.length <= right) {
            throw new FEXception('ArrayOutOfBounds. Accessing position ' + right + ' on array with size: ' + left.length);
         }
         return left[right];
      } else if (ast.type == this.TYPE_IDENTIFIER) {
         // console.log('[FEX] Detected identifier: ' + ast.text);
         if (!idSolver) {
            throw new FEXception('No id solver set and need to solve ' + ast.text + ' to a value');
         }
         var idValue = idSolver(ast.text, true);
         if (idValue === undefined) {
            throw new FEXception('Id solver did not solve ' + ast.text);
         }
         return idValue;
      } else if (ast.type == this.TYPE_NUMBER) {
         // console.log('[FEX] Detected number: ' + ast.text);
         return parseFloat(ast.text);
      } else if (ast.type == this.TYPE_STRING) {
         // console.log('[FEX] Detected string: ' + ast.text);
         return ast.text;
      } else if (ast.type == this.TYPE_BOOLEAN) {
         // console.log('[FEX] Detected boolean: ' + ast.text);
         return (ast.text === 'true');
      } else if (ast.type == this.TYPE_FUNCTION) {
         var args = new Array();
         // console.log('[FEX] Detected function: ' + ast.text + ' with ' + ast.arguments.length + ' arity');
         for (var i=0; i < ast.arguments.length; i++) {
            console.log('[FEX] Argument: ' + i + ' -> ' + ast.arguments[i]);
            args.push(this.evaluate(ast.arguments[i], idSolver, fncExecutor));
         }
         if (!fncExecutor) {
            throw new FEXception('No function executor set and need to execute ' + ast.text);
         }
         var fncValue = fncExecutor(ast.text, args);
         if (fncValue === undefined) {
            throw new FEXception('Function executor did not execute ' + ast.text);
         }
         return fncValue;
      } else {
         throw 'Unable to parse type: ' + ast.type;
      }
   }

   this.getIdentifiers = function(ast) {
      var stack = new Array();

      stack.push(ast);
      var ret = new Array();
      while (stack.length > 0) {
         var item = stack.pop();

         if (item.type == FE$XInterpreter.TYPE_IDENTIFIER) {
            ret.push(item.text);
         } else if (item.type == FE$XInterpreter.TYPE_FUNCTION) {
            for (var i=0; i < item.arguments.length; i++) {
               stack.push(item.arguments[i]);
            }
         } else if (item.type == FE$XInterpreter.TYPE_OPERATION) {
            
            stack.push(item.left);
            if (!item.isUnary) {
               stack.push(item.right);
            }
            
         } else if (item.type == FE$XInterpreter.TYPE_ARRAYOFFSET) {
            stack.push(item.left);
            stack.push(item.right);
         } else if (item.type == FE$XInterpreter.TYPE_SUBFIELD) {
            stack.push(item.left); // The right elements always reference to subfields
         }

      }
      return ret;
   }

   var operate = function(operation, left, right) {
      var boolOps = ['not', 'and', 'or'];
      if (FE$XUtils.matchesAny(operation, boolOps)) {
         // Check that both operands are boolean
         if (typeof left != 'boolean') {
            throw new FEXception('Wrong type detected on boolean operation: ' + left);
         }
         if (right && typeof right != 'boolean') {
            throw new FEXception('Wrong type detected on boolean operation: ' + right);
         }
      } else if (operation != '==' && operation != '!=' && operation != '+') {
         // Check that both operands are numbers
         if (typeof left != 'number') {
            throw new FEXception('Wrong type detected on numerical operation (' + operation + '): ' + left);
         }
         if (right && typeof right != 'number') {
            throw new FEXception('Wrong type detected on numerical operation (' + operation + '): ' + right);
         }
      }
      if (operation == '*') {
         return left * right;
      } else if (operation == '+') {
         return left + right;
      } else if (operation == '-') {
         return left - right;
      } else if (operation == '/') {
         return left / right;
      } else if (operation == 'not') {
         return !left;
      } else if (operation == 'or') {
         return left || right;
      } else if (operation == 'and') {
         return left && right;
      } else if (operation == '>') {
         return left > right;
      } else if (operation == '<') {
         return left < right;   
      } else if (operation == '>=') {
         return left >= right;
      } else if (operation == '<=') {
         return left <= right;
      } else if (operation == '==') {
         // console.log('[FEX] Evaluating ' + left + ' (' + (typeof left) + ') == ' + right+ ' (' + (typeof right) + ')');
         return ''+left == ''+right;       
      } else if (operation == '!=') {
         return ''+left != ''+right;
      } else {
         throw 'Unknown operation ' + operation;
      }
   }

   var getOpPrecedence = function(op) {
      for (var i=0; i < OP_PRECEDENCE.length; i++) {
         if (op == OP_PRECEDENCE[i]) {
            return OP_PRECEDENCE.length - i;
         }
      }
      return 10000;
   }
   var popOperation = function(operandStack, operatorStack) {
      var operator = operatorStack.pop();

      var ret = {
         type: FE$XInterpreter.TYPE_OPERATION,
         text: operator,
         
         
      }
      if (!FE$XUtils.matchesAny(operator, OP_UNARY)) { // Not unary...add right operand
         ret.right = operandStack.pop();
         ret.isUnary = false;
      } else {
         // console.log('[FEX] Detected unary operator');
         ret.isUnary = true;
      }
      ret.left = operandStack.pop();
      return ret;

   }

   /** 
    * Function that parses complex identifiers
    */
   this.parseIdentifier = function(identName, tokens) {
      var currNode = {
         type: FE$XInterpreter.TYPE_IDENTIFIER,
         text: identName,

      };
      while (tokenIndex < tokens.length) { // Check if the identifier has sub identifiers or array
         if (tokens[tokenIndex].token == FE$XITokenizer.TOKEN_SQBRACKETOPEN) { // Array
            tokenIndex ++;
            var arrIndex = this.parseStep(tokens);
            currNode = {
               type: FE$XInterpreter.TYPE_ARRAYOFFSET,
               text: '[]',
               left: currNode,
               right: arrIndex
            }
            if (tokens[tokenIndex].token != FE$XITokenizer.TOKEN_SQBRACKETCLOSE) {
               throw new FEXception('Expected square bracket close but found: ' + JSON.stringify(tokens[tokenIndex]));
            }
            tokenIndex ++;
         } else if (tokens[tokenIndex].token == FE$XITokenizer.TOKEN_FIELDSEPARATOR 
            && tokens[tokenIndex + 1].token == FE$XITokenizer.TOKEN_IDENTIFIER) { // Subidentifier
            tokenIndex ++;
            var subIdentName = tokens[tokenIndex].string;
            var subId = {
               type: FE$XInterpreter.TYPE_IDENTIFIER,
               text: subIdentName,
            };
            tokenIndex ++;
            currNode = {
               type: FE$XInterpreter.TYPE_SUBFIELD,
               text: '.',
               left: currNode,
               right: subId
            }
         } else {
            break;
         }

      }
      return currNode;
   }
   this.parseFunction = function(fncName, tokens) {
      var operandStack = new Array();
      var operatorStack = new Array();
      // console.log('[FEX] Parsing function with identifier: ' + fncName);
      while (tokenIndex < tokens.length && tokens[tokenIndex - 1].token != FE$XITokenizer.TOKEN_BRACKETCLOSE) {
         var ret = this.parseStep(tokens)
         if (ret) { // Make sure there is a ret value (can be function without arguments and call would return nothing)
            operandStack.push(ret);
         }
         
      }
      if (tokens[tokenIndex - 1].token != FE$XITokenizer.TOKEN_BRACKETCLOSE) {
         throw new FEXception('Unexpected end of function. Expected bracket close but found: ' + (tokenIndex - 1 >= tokens.length?'<Exhausted tokens>':JSON.stringify(tokens[tokenIndex - 1])));
      }
      // tokenIndex++; // Skip bracket close

      var ret = {
         type: FE$XInterpreter.TYPE_FUNCTION,
         arguments: operandStack,
         text: fncName
      };
      // console.log('[FEX] Function node defined as: ' + JSON.stringify(ret));
      return ret;
   }
   

   this.parseStep = function(tokens) {
      var operandStack = new Array();
      var operatorStack = new Array();
      
      while (tokenIndex < tokens.length) {
         console.log('[FEX] Parsing Index: ' + tokenIndex + ': ' + JSON.stringify(tokens[tokenIndex]));
         console.log('[FEX] Operand stack: ' + JSON.stringify(operandStack));
         var pushedOperand = false;

         if (tokens[tokenIndex].token == FE$XITokenizer.TOKEN_OPERATOR) {
            console.log('[FEX] Detected operation: ', tokens[tokenIndex]);

            while (operatorStack.length > 0 && getOpPrecedence(tokens[tokenIndex].string) < getOpPrecedence(operatorStack[operatorStack.length - 1])) {
               // console.log('[FEX] Popping operation due to low precedence of ' + tokens[tokenIndex].string + '(' + getOpPrecedence(tokens[tokenIndex].string) + ') against ' + operatorStack[operatorStack.length - 1].string + '(' + getOpPrecedence(operatorStack[operatorStack.length - 1]) + ')' )
               operand = popOperation(operandStack, operatorStack);
               operandStack.push(operand);
            }
            
            operatorStack.push(tokens[tokenIndex].string)
            tokenIndex ++;
            
         } else if (tokens[tokenIndex].token == FE$XITokenizer.TOKEN_IDENTIFIER) {
            console.log('[FEX] Detected identifier "' + tokens[tokenIndex].string + '"...is function?');
            if (tokenIndex < tokens.length - 1 && tokens[tokenIndex+1].token == FE$XITokenizer.TOKEN_BRACKETOPEN) {
               console.log('[FEX] Detected identifier "' + tokens[tokenIndex].string + '"...IS FUNCTION');
               var fncName = tokens[tokenIndex].string;

               tokenIndex += 2;
               operandStack.push(this.parseFunction(fncName, tokens));
            } else {
               var identName = tokens[tokenIndex].string;
               console.log('[FEX] Detected identifier "' + tokens[tokenIndex].string + '"...NO FUNCTION');
               tokenIndex ++;
               operandStack.push(this.parseIdentifier(identName, tokens));
               
               
            }
            
         } else if (tokens[tokenIndex].token == FE$XITokenizer.TOKEN_NUMBER) {
            operandStack.push({
               type: FE$XInterpreter.TYPE_NUMBER,
               text: tokens[tokenIndex].string
            });
            tokenIndex++;
         } else if (tokens[tokenIndex].token == FE$XITokenizer.TOKEN_STRING) {
            operandStack.push({
               type: FE$XInterpreter.TYPE_STRING,
               text: tokens[tokenIndex].string
            });
            tokenIndex++;
         } else if (tokens[tokenIndex].token == FE$XITokenizer.TOKEN_BOOLEAN) {
            operandStack.push({
               type: FE$XInterpreter.TYPE_BOOLEAN,
               text: tokens[tokenIndex].string
            });
            tokenIndex++;
         } else if (tokens[tokenIndex].token == FE$XITokenizer.TOKEN_BRACKETCLOSE) { // Exit
            console.log('[FEX] Detected bracket close...breaking context'); 
            tokenIndex++;
            break; // Exit parsing
         } else if (tokens[tokenIndex].token == FE$XITokenizer.TOKEN_SQBRACKETCLOSE) { // Exit
            console.log('[FEX] Detected square bracket close...breaking context'); 
            
            break; // Exit parsing
         } else if (tokens[tokenIndex].token == FE$XITokenizer.TOKEN_ARGSEPARATOR) { // Exit...within function parsing
            tokenIndex ++;
            break;
         } else if (tokens[tokenIndex].token == FE$XITokenizer.TOKEN_BRACKETOPEN) { // Recursive
            tokenIndex ++;
            operandStack.push(this.parseStep(tokens));
         } else {
            throw new FEXception('Not handled token: ' + JSON.stringify(tokens[tokenIndex]));
         }
      }
      console.log('[FEX] Finished tokens or exitted context with: \nOperators -> ' + JSON.stringify(operatorStack) + '\nOperands -> ' + JSON.stringify(operandStack));
      // Remove all pending operations
      while (operatorStack.length > 0) {
         var operand = popOperation(operandStack, operatorStack);
         console.log('[FEX] Popping operand: ' + JSON.stringify(operand));
         operandStack.push(operand);
      }

      if (operandStack.length > 1 || operatorStack > 0) {
         console.log('[FEX] Expected no operands nor operators when exiting context.\n Operands: ' +  JSON.stringify(operandStack) + '\n Operators: ' + JSON.stringify(operatorStack));

         throw new FEXception('Expected no operands nor operators when exiting context.Operands: ' +  JSON.stringify(operandStack) + 'Operators: ' + JSON.stringify(operatorStack));
      }
      return operandStack.pop();
   }
}


function FE$XITokenizer_def() {

   this.TOKEN_BRACKETOPEN = 0;
   this.TOKEN_BRACKETCLOSE = 1;
   this.TOKEN_STRING = 2;
   this.TOKEN_IDENTIFIER = 3;
   this.TOKEN_OPERATOR = 4;
   this.TOKEN_ARGSEPARATOR = 5;
   this.TOKEN_NUMBER = 6;
   this.TOKEN_BOOLEAN = 7;
   this.TOKEN_FIELDSEPARATOR = 8;
   this.TOKEN_SQBRACKETOPEN = 9;
   this.TOKEN_SQBRACKETCLOSE = 10;


   this._skipSpaces = function(str) {
      if (str.length == 0) return str;

      while (str[0] == ' ' || str[0] == '\t') {
         str = str.slice(1, str.length);
      }
      return str;
   }

   this._detectOpenParen = function(str, tokens) {
      if (str.length == 0) return str;

      if (str[0] == '(') {
         // console.log('[FEX] Detected bracket open');
         tokens.push({token: this.TOKEN_BRACKETOPEN, string: str[0], sToken: 'bracketOpen'});
         str = str.slice(1, str.length);
         
      }
      return str;
   }
   this._detectCloseParen = function(str, tokens) {
      if (str.length == 0) return str;

      if (str[0] == ')') {
         // console.log('[FEX] Detected bracket close');
         tokens.push({token: this.TOKEN_BRACKETCLOSE, string: str[0], sToken: 'bracketClose'});
         str = str.slice(1, str.length);
         
      }
      return str;
   }

   this._detectString = function(str, tokens) {
      if (str.length == 0) return str;

      if (str[0] == '\'') {
         // console.log('[FEX] Considering string: ' + sToken);
         var sToken = ''; // str[0];
         str = str.slice(1, str.length);
         while (str[0] != '\'' && str.length > 0) {
            sToken += str[0];
            // console.log('[FEX] Growing string: ' + sToken);
            str = str.slice(1, str.length);
         }
         if (str.length > 0) {
            // sToken += '\'';
            str = str.slice(1, str.length);
            tokens.push({token: this.TOKEN_STRING, string: sToken, sToken: 'string'});
         } else {
            throw new FEXception('Detected non-closed string');
         }
      }
      return str;
   }

   this._detectIdentifier = function(str, tokens) {
      if (str.length == 0) return str;

      var RE = new RegExp('^[a-zA-Z][a-zA-Z0-9]*$');

      if (RE.test(str[0])) {

         var sToken = str[0];
         // console.log('[FEX] Considering identifier: ' + sToken);
         str = str.slice(1, str.length)
         while (RE.test(sToken + str[0]) && str.length > 0) {
            sToken += str[0];
            str = str.slice(1, str.length);
            // console.log('[FEX] Growing identifier: ' + sToken);
         }
         tokens.push({token: this.TOKEN_IDENTIFIER, string: sToken, sToken: 'identifier'});
      }
      return str;
   }

   var startsAlike = function(str, options) {
      for (var i=0; i < options.length; i++) {
         if (options[i].indexOf(str) == 0) {
            return true;
         }
      }
      return false;
   }
   
   this._detectFieldSeparator = function(str, tokens) {
      if (str.length == 0) return str;
      if (str.charAt(0) == '.') {
         var sToken = str.substring(0, 1);
         tokens.push({token: this.TOKEN_FIELDSEPARATOR, string: sToken, sToken: 'fieldSeparator'});
         str = str.slice(1, str.length);
      }
      return str;
   }
   this._detectOperator = function(str, tokens) {
      if (str.length == 0) return str;
      var operators = [ '==', '!=', '>', '<', '>=', '<=', '*', '+', '-', '/'];

      var isOp = false;
      if (startsAlike(str[0], operators)) {
         var sToken = str[0];
         str = str.slice(1, str.length);
         while (startsAlike(sToken + str[0], operators)) {
            sToken += str[0];
            str = str.slice(1, str.length);
         }
         if (FE$XUtils.matchesAny(sToken, operators)) {
            tokens.push({token: this.TOKEN_OPERATOR, string: sToken, sToken: 'operator'});
         } else {
            str = sToken + str; // Keep as it was. Probably we can parse as identifier
         }
      }
      return str;
      
   }
   this._detectSquareBracketOpen = function(str, tokens) {
      if (str.length == 0) return str;

      if (str[0] == '[') {
         var sToken = str.substring(0, 1);
         tokens.push({token: this.TOKEN_SQBRACKETOPEN, string: sToken, sToken: 'squareBracketClose'});
         str = str.slice(1, str.length);
      }
      return str;
   }
   this._detectSquareBracketClose = function(str, tokens) {
      if (str.length == 0) return str;

      if (str[0] == ']') {
         var sToken = str.substring(0, 1);
         tokens.push({token: this.TOKEN_SQBRACKETCLOSE, string: sToken, sToken: 'squareBracketClose'});
         str = str.slice(1, str.length);
      }
      return str;
   }
   this._detectNumber = function(str, tokens) {

      if (str.length == 0) return str;
      console.log('[FEXI] Attempting number with ' + str);
      if (str[0] == '-' && str.length < 2) { // Negative numbers require at least 2 digits
         return;
      }
      var sToken = '';
      var remaining = str;
      if (remaining[0] == '-') {
         sToken = '-';
         remaining = remaining.slice(1, remaining.length);
      }
      while ((sToken + remaining[0]).match('^-?[0-9]+$')) {
         sToken += remaining[0];
         remaining = remaining.slice(1, remaining.length);
      }

      if (sToken.length > 0) {
         tokens.push({token: this.TOKEN_NUMBER, string: sToken, sToken: 'number'});
         return remaining;
      } else {
         // console.log('[FEXI] Desisting number....returning "' + str + '"');
      }
      return str;
   }

   this._detectBoolean = function(str, tokens) {
      if (str.length == 0) return str;
      if (/^true\b/.test(str)) {
         tokens.push({token: this.TOKEN_BOOLEAN, string: 'true', sToken: 'boolean'});
         str = str.slice(4, str.length);
      } else if (/^false\b/.test(str)) {
         tokens.push({token: this.TOKEN_BOOLEAN, string: 'false', sToken: 'boolean'});
         str = str.slice(5, str.length);
      }
      return str;
   }
   this._detectArgSeparator = function(str, tokens) {
      if (str.length == 0) return str;
      if (str[0] == ',') {
         tokens.push({token: this.TOKEN_ARGSEPARATOR, string: str[0], sToken: 'argSeparator'});
         str = str.slice(1, str.length);
      }
      return str;
   }
   


   this.tokenize = function(str) {
      var tokens = new Array();
      console.log('[FEXI] Tokenizing "' + str + '"');
      var lastLength = str.length;
      while (str.length > 0) {
         str = this._skipSpaces(str);
         str = this._detectOpenParen(str, tokens);
         str = this._detectCloseParen(str, tokens);
         str = this._detectNumber(str, tokens);
         str = this._detectOperator(str, tokens);
         str = this._detectString(str, tokens);
         str = this._detectBoolean(str, tokens);
         str = this._detectIdentifier(str, tokens);
         str = this._detectArgSeparator(str, tokens);
         str = this._detectFieldSeparator(str, tokens);
         str = this._detectSquareBracketOpen(str, tokens);
         str = this._detectSquareBracketClose(str, tokens);
         
         if (lastLength == str.length) {
            throw new FEXception('Unable to parse string. Lock on ' + str);
         }
         lastLength = str.length;
         // console.log('[FEX] Parsed: ' + lastLength + ' - Remaining: "' + str + '"');
      }

      // After tokenizing some of the operatos can be detected as identifiers..check them and change accordingly
      var OPS_ASIDS = ['not', 'and', 'or'];
      for (var i=0; i < tokens.length; i++) {
         if (FE$XUtils.matchesAny(tokens[i].string, OPS_ASIDS)) {
            tokens[i].token = this.TOKEN_OPERATOR;
            tokens[i].sToken = 'operator';
         }
      }
      console.log('[FEX] Tokens: ', tokens);
      return tokens;
   }
}

var FE$XInterpreter = new FE$XInterpreter_def();
var FE$XITokenizer = new FE$XITokenizer_def();


export {FE$BaseFunctionExecutor, FE$XInterpreter, FE$XITokenizer};